import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import ProfileContactSection from '/component/partial/profile/ProfileContactSection';
import {withTranslation} from '/provider/TranslationProvider';
import {
  accountEmailById,
  addressCityStateById,
  phoneNumberById,
  urlDetailsById,
} from '/redux/selector/client.selector';
import {withHOC} from '/util/hoc.util';

export default withHOC(
  connect(
    createStructuredSelector({
      accountEmail: accountEmailById,
      phoneNumber: phoneNumberById,
      cityState: addressCityStateById,
      urlDetails: urlDetailsById,
    }),
  ),
  withTranslation('screen.clientProfile.section.contact'),
)(ProfileContactSection);
